<div class="flex flex-col w-full pb-2">
  @if (authService.isLoggedIn()) {
    <div
      class="flex flex-col inset-x-0 bottom-0 w-full">
      <div class="flex flex-row py-2 px-4 w-full">
        <div class=" w-full border-t border border-white rounded-lg opacity-100"></div>
      </div>
      <!--Lower Actions Level-->
      @if (authService.isLoggedIn()) {
        <div class="flex flex-row w-full justify-between items-center px-6">

          <button
            (click)="performRouteLink('checkout')"
            class="tooltip-fix bg-[rgba(255,255,255,0.35)] rounded-full h-8 w-8 hover:bg-[rgba(217,224,226,0.45)] hover:cursor-pointer"
            tooltip="Shop"
            tooltipDirection="top"
            tooltipColor="light">
            <fa-icon [icon]="faBagShopping" class="text-white text-[18px]"></fa-icon>
          </button>

          <button
            (click)="performRouteLink('profile')"
            class="tooltip-fix bg-[rgba(255,255,255,0.35)] rounded-full h-8 w-8 hover:bg-[rgba(217,224,226,0.45)] hover:cursor-pointer" tooltip="Profil"
            tooltipDirection="top" tooltipColor="light">
            <fa-icon [icon]="faUser" class="text-white text-[18px]"></fa-icon>
          </button>
          <!--  Cloud loading icon, currently disabled-->
          @if (false && stateConfigService.runningChecks.length > 0) {
            <div>
              <div #trigger="cdkOverlayOrigin" (mouseenter)="showAnalysisMenu = false" (mouseleave)="showAnalysisMenu = false"
                   cdkOverlayOrigin
                   class="hover:bg-gray-500 hover:cursor-pointer hover:rounded-lg" routerLink="reports">
                <app-cloud-number [analysisLoading]="true"
                                  [loading]="true" [matTooltipClass]="'blue-tooltip'"
                                  matTooltip="Mindestens eine Prüfung läuft"></app-cloud-number>
              </div>
              <ng-template
                [cdkConnectedOverlayOpen]="showAnalysisMenu"
                [cdkConnectedOverlayOrigin]="trigger"
                cdkConnectedOverlay
              >
                <mat-card appearance="outlined">
                  <h2>Laufende Analysen</h2>
                  <mat-dialog-content>
                    @for (analysis of stateConfigService.runningChecks | keyvalue; track analysis) {
                      <div class="flex flex-row">
                        <h4>{{ analysis.key }}:&nbsp;</h4>
                        @for (lphCheck of $any(analysis.value); track lphCheck) {
                          <h4>{{ lphCheck }}&nbsp;</h4>
                        }
                      </div>
                    }
                  </mat-dialog-content>
                </mat-card>
              </ng-template>
            </div>
          }
          <button
            (click)="performRouteLink('whats-new')"
            class="tooltip-fix relative bg-[rgba(255,255,255,0.35)] rounded-full h-8 w-8 hover:bg-[rgba(217,224,226,0.45)] hover:cursor-pointer"
            tooltip="Versionsverlauf"
            tooltipColor="light" tooltipDirection="top">
            <fa-icon [icon]="faBell" class="text-white text-[18px]"></fa-icon>
            @if (hasUnseenVersion) {
              <div class="absolute top-0 right-0 h-2 w-2 rounded-full bg-red-500"></div>
            }
          </button>

          <button
            (click)="performRouteLink('logout')"
            class="tooltip-fix bg-[rgba(255,255,255,0.35)] rounded-full h-8 w-8 hover:bg-[rgba(217,224,226,0.45)] hover:cursor-pointer" tooltip="Abmelden"
            tooltipDirection="top" tooltipColor="light">
            <fa-icon [icon]="faRightFromBracket" class="text-white text-[18px]"></fa-icon>
          </button>
        </div>
      }
    </div>
  }

</div>
